import { render, staticRenderFns } from "./IconDrag.vue?vue&type=template&id=2e5d5d7c&scoped=true"
import script from "./IconDrag.vue?vue&type=script&lang=js"
export * from "./IconDrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d5d7c",
  null
  
)

export default component.exports